import React from "react"
import { useBlocks } from "app/regions/hooks/use-blocks"
import { serialize } from "core/editor/serializer"
import { Value } from "@convertkit/slate"
import { useInheritedTheme } from "@convertkit/editor"

export function TextEmail({ id }) {
  const { properties } = useBlocks(id)
  const { find } = useInheritedTheme()

  const html =
    properties.value && serialize(Value.fromJSON(properties.value), { find })

  return (
    <div
      key={id}
      className="spaced-contents"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  )
}
